import { h$1 as l, h as p, Y as t, m as v, o as h } from "../chunks/register-Ba9sFUKZ.js";
import * as u from "react";
import { u as g } from "../chunks/class-map-B8OdeXIO.js";
import { i as w } from "../chunks/modal-CByDgtcf.js";
import { c as s } from "../chunks/scrollableRegion-C7w1KYaq.js";
import { u as r } from "../chunks/showIfUsed-5lEKgJ0L.js";
const m = {
  beaconTagName: "beacon-modal"
}, x = l`[beacon-tag-name=beacon-modal] :where([slot=logo] :where(img,svg)){block-size:inherit;inline-size:inherit}`, k = l`:host{--header-justification: space-between;--modal-max-block-size: calc(100dvh - 2 * var(--beacon-system-space-gutter))}dialog{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: none;border-radius:var(--beacon-system-radius-corner-standard);box-shadow:var(--beacon-system-color-shadow-high);max-block-size:var(--modal-max-block-size)}@media (width >= 640px){dialog{--default-width: 100%}}.persist .header{padding:0}.persist .logo-slot{padding:var(--beacon-system-space-cell-contained)}.normal{inset-block-end:var(--beacon-system-space-gutter);inset-block-start:initial}@media (width >= 640px){.normal{--max-width: 23.625rem;--min-width: 17.625rem;top:0;right:0;bottom:0;left:0}}@media (width >= 960px){.normal{--max-width: 45.5rem;--min-width: 26.5rem}}:is(.jumbo,.maxi){--max-width: 100%;--min-width: 100%;top:0;right:0;bottom:0;left:0}@media (width < 640px){:is(.jumbo,.maxi){block-size:100dvh;margin-block:0;max-block-size:none}:is(.jumbo,.maxi) .wrapper{block-size:100dvh;max-block-size:100dvh}}@media (width >= 640px){.jumbo{--max-width: 36rem;--min-width: none}}@media (width >= 960px){.jumbo{--max-width: 44rem}}@media (width >= 1280px){.jumbo{--max-width: 57rem}}@media (width >= 640px){.maxi{--max-width: calc(100% - 2 * var(--beacon-system-space-gutter));--min-width: calc(100% - 2 * var(--beacon-system-space-gutter))}}.wrapper{max-block-size:var(--modal-max-block-size)}@media (width >= 1216px){.wrapper.maxi{grid-template-areas:"panel header" "panel content" "panel footer";grid-template-columns:4fr 8fr}.wrapper.maxi .body{display:contents}.wrapper.maxi .header{grid-area:header}.wrapper.maxi .panel{grid-area:panel}.wrapper.maxi .content{grid-area:content}.wrapper.maxi .footer{grid-area:footer}.wrapper.maxi .content,.wrapper.maxi .panel{overflow-y:auto;scrollbar-color:var(--beacon-component-scrollbar-color-background-thumb) var(--beacon-component-scrollbar-color-background-track);scrollbar-gutter:stable}}.content{padding-block:var(--beacon-system-space-organism-jumbo);padding-inline:var(--beacon-system-space-organism-jumbo)}.panel{background-color:var(--beacon-system-color-background-2);padding:var(--beacon-system-space-organism-jumbo)}.close-button{margin-inline-start:auto}::slotted([slot=logo]){block-size:100%;inline-size:100%;max-block-size:var(--beacon-reference-space-10);max-inline-size:var(--beacon-reference-space-10)}`;
var y = Object.defineProperty, f = (e, o, c, z) => {
  for (var a = void 0, i = e.length - 1, d; i >= 0; i--)
    (d = e[i]) && (a = d(o, c, a) || a);
  return a && y(o, c, a), a;
};
const b = class extends w {
  constructor() {
    super(...arguments), this.beaconTagName = m.beaconTagName, this.scale = "normal";
  }
  static get styles() {
    return [super.styles, k];
  }
  static get lightDOMStyles() {
    return [super.lightDOMStyles, x];
  }
  /**
   * @todo 4.0.0 Rename to something other than `additional-content`
   */
  renderSidePanel() {
    return this.scale !== "maxi" ? t`` : t`
      <div class="panel" tabindex=${s()}>
        <slot
          name="additional-content"
          ${r({ useParent: !0 })}></slot>
      </div>
    `;
  }
  render() {
    const o = {
      persist: this.persist
    };
    return o[this.scale] = !0, t`
      ${this.anyComputedZIndex && this.open ? t`<div class="non-modal-dialog-background-wrapper"></div>` : ""}
      <dialog
        @click=${this.handleDialogClick}
        class="${g(o)}">
        <div class="block-size-wrapper">
          <div class="wrapper ${this.scale}">
            <div class="header">
              <div class="logo-slot">
                <slot
                  name="logo"
                  aria-hidden="true"
                  ${r({ useParent: !0 })}></slot>
              </div>
              ${this.renderCloseButton()}
            </div>
            <div class="body" tabindex=${s()}>
              <div class="content" tabindex=${s()}>
                <slot ${r({ container: ".body" })}></slot>
              </div>
              ${this.renderSidePanel()}
            </div>
            <div class="footer">
              <div class="action-zone">
                <slot
                  name="action-zone"
                  ${r({ container: ".footer" })}></slot>
              </div>
            </div>
          </div>
        </div>
      </dialog>
    `;
  }
};
b.tagName = m.beaconTagName;
let n = b;
f([
  p()
], n.prototype, "scale");
const M = (e) => (v(e, n), h({
  tagName: e ? e + "-" + n.tagName : n.tagName,
  elementClass: n,
  react: u,
  events: {
    onBeaconEventOpen: "beacon-event-open",
    onBeaconEventClose: "beacon-event-close",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  M as default,
  M as reactBeaconModal
};
